"use client";

import { useState, useEffect } from "react";
import { useAuth } from "@/components/auth/AuthProvider";
import { useAnalytics } from "@/lib/analytics";

/**
 * MobileBottomCTA — fixed bottom bar on mobile only.
 * Appears on scroll (after 400px), with short copy + CTA button.
 * Dismissable with X.
 */
export default function MobileBottomCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { openAuth } = useAuth();
  const { track } = useAnalytics();

  useEffect(() => {
    const handleScroll = () => {
      if (dismissed) return;
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dismissed]);

  if (!visible || dismissed) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-between gap-3 bg-black px-4 py-2.5 shadow-[0_-2px_12px_rgba(0,0,0,0.15)] sm:hidden">
      <p className="min-w-0 flex-1 text-[11px] leading-tight text-white/90">
        Every comment you miss is a sale you lose. Set up auto-DMs in 5 minutes.
      </p>
      <button
        type="button"
        onClick={() => {
          track("cta_clicked", { cta_id: "CTA_Mobile_Bottom_Bar", button_text: "Start Free" });
          openAuth();
        }}
        className="shrink-0 rounded-full bg-primary-gradient px-4 py-1.5 text-xs font-bold text-primary-foreground transition-opacity hover:opacity-90"
      >
        Start Free
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="shrink-0 p-1 text-white/60 transition-colors hover:text-white"
        aria-label="Dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>
  );
}
